var attributeObj = [];
var getDefData = [];
function getParameterByNamekorra(name, url) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?]' + name + '(=([^?#]*)|&|#|$)'),
  results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, '+'));
}

function attrObj(attributeObj){
  var attributeObjnew = {};
  attributeObjnew["attributes"] = attributeObj;
  console.log(attributeObj,"attributeObj ss attr here");
  
  console.log(JSON.stringify(attributeObjnew),"custom here ss attr, new 1");
  
  $('[name="properties[_attributes]"]').val(JSON.stringify(attributeObjnew));
}

function manageCustomizeSemiStitched(){
  console.log("manageCustomizeSemiStitched>>>>>>>>>>>>");

$(document).on('click','.product-fitsmart-main:not(.shirt) .ProductSize__ShirtSize [type="radio"]',function(){
  var sizeSemiStit = $(this).val();
  if(sizeSemiStit >= '40'){
    setTimeout(function(){
      var riseVal = $('.customise-new_measure .ProductSize__Rise [name="properties[_Rise?]"].activeradio').val();
      console.log('riseVal',riseVal)
      if(riseVal != 'Low'){
        $('.customise-new_measure .ProductSize__Rise [value="Low"]').click();
      }
    },500)
    $('.ProductSize__Elements.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.Property__Field').addClass('hide');
  }else{
    $('.ProductSize__Elements.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.Property__Field').removeClass('hide');
  }
});

var sizeJson = {
  "athletic": {xs:"39-39,34.5-35.5",s:"41-41,36.5-37.5",m:"43-43,38.5-39.5",l:"45-45,40.5-41.5",xl:"48-48,44-45"},
  "average": {xs:"39-39,34.5-35.5",s:"41-41,36.5-37.5",m:"43-43,38.5-39.5",l:"45-45,40.5-41.5",xl:"48-48,44-45",xxl:"50-50,47-48",xxxl:"52-52,49-50"},
  "healthy": {m:"43-43,41-41",l:"45-45,43-43",xl:"48-48,46.5-46.5",xxl:"50-50,49.5-49.5",xxxl:"52-52,51.5-51.5",'4xl':"54-54,53.5-53.5"}
}
var sizeJsonCM = {
  "athletic": {xs:"99.0-99.0,87.5-90.0",s:"104.0-104.0,92.5-95.0",m:"109.0-109.0,97.5-100.0",l:"114.0-114.0,103.0-105.5",xl:"122.0-122.0,111.5-114.5"},
  "average": {xs:"99.0-99.0,87.5-90.0",s:"104.0-104.0,92.5-95.0",m:"109.0-109.0,97.5-100.0",l:"114.0-114.0,103.0-105.5",xl:"122.0-122.0,111.5-114.5",xxl:"127.0-127.0,119.5-122.0",xxxl:"132.0-132.0,124.5-127.0"},
  "healthy": {m:"109.0-109.0,104.0-104.0",l:"114.5-114.5,109.2-109.2",xl:"122.0-122.0,118.0-118.0",xxl:"127.0-127.0,125.5-125.5",xxxl:"132.0-132.0,131.0-131.0",'4xl':"137.0-137.0,136.8-135.8"}
}

function draggableTable(slider){
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
  });
}



// function draggableTable(slider){
//   let isDown = false;
//   let startX;
//   let scrollLeft;
//   console.log('slider--',slider);
//   slider.addEventListener('mousedown', (e) => {
//     isDown = true;
//     slider.classList.add('active');
//     startX = e.pageX - slider.offsetLeft;
//     scrollLeft = slider.scrollLeft;
//   });
//   slider.addEventListener('mouseleave', () => {
//     isDown = false;
//     slider.classList.remove('active');
//   });
//   slider.addEventListener('mouseup', () => {
//     isDown = false;
//     slider.classList.remove('active');
//   });
//   slider.addEventListener('mousemove', (e) => {
//     if(!isDown) return;
//     e.preventDefault();
//     const x = e.pageX - slider.offsetLeft;
//     const walk = (x - startX) * 3; //scroll-fast
//     slider.scrollLeft = scrollLeft - walk;
//   });
// }
var getUrlParameter_cart = function getUrlParameter_cart(sParam){
  var sPageURL = window.location.search.substring(1),
  sURLVariables = sPageURL.split('&'),
  sParameterName,
  i;  
  for(i = 0; i < sURLVariables.length; i++){
    sParameterName = sURLVariables[i].split('=');  
    if(sParameterName[0] === sParam){
      return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};
jQuery.getJSON('/cart.json', function(cart){
 var cartdata = cart.items;
 var cart_itemid = getUrlParameter_cart('itemid');
  if($('body').hasClass('temp_webview')){
    var webitem_id = getUrlParameter('web_itemid');
    if(webitem_id){
      var web_id = atob(getUrlParameter('web_itemid'));
      var ordeId = atob(getUrlParameter('ck'));
      var access_token = getUrlParameter('accessToken');
    }  
    console.log('web_id',web_id);
    console.log('ordeId',ordeId);
    console.log('access_token',access_token);   
    if(web_id){
    if(ordeId.includes("Checkout")){
      var settings = {
        "url": "https://www.bombayshirts.com/api/2022-10/graphql.json",
        "method": "POST",
        "timeout": 0,
        "headers": {
        "x-shopify-storefront-access-token": "0c4e8875084a8dd2cb70176e69465741",
        "Content-Type": "application/json",
        "Cookie": "request_method=POST"
        },
        "data": JSON.stringify({
          query: "{\r\n  node(\r\n    id: \""+ordeId+"\"\r\n  ) {\r\n    ... on Checkout {\r\n      id\r\n      webUrl\r\n      email\r\n      order {\r\n        id\r\n      }\r\n      customAttributes {\r\n        key\r\n        value\r\n      }\r\n      shippingLine {\r\n        handle\r\n        price {\r\n          amount\r\n          currencyCode\r\n        }\r\n        title\r\n      }\r\n      shippingAddress {\r\n        address1\r\n        address2\r\n        city\r\n        company\r\n        country\r\n        countryCodeV2\r\n        firstName\r\n        id\r\n        lastName\r\n        latitude\r\n        longitude\r\n        name\r\n        phone\r\n        province\r\n        provinceCode\r\n        zip\r\n      }\r\n      lineItems(first: 250) {\r\n        edges {\r\n          node {\r\n            id\r\n            title\r\n            customAttributes {\r\n              key\r\n              value\r\n            }\r\n            unitPrice {\r\n              amount\r\n              currencyCode\r\n            }\r\n            variant {\r\n              id\r\n              image {\r\n                url(transform: { maxWidth: 250 })\r\n              }\r\n              product {\r\n                id\r\n                vendor\r\n                handle\r\n                productType\r\n                tags\r\n                product_sku: metafield(namespace: \"my_fields\", key: \"sku\") {\r\n                  value\r\n                }\r\n              }\r\n              compareAtPrice {\r\n                amount\r\n                currencyCode\r\n              }\r\n              price {\r\n                amount\r\n                currencyCode\r\n              }\r\n              title\r\n            }\r\n            quantity\r\n            discountAllocations {\r\n              allocatedAmount {\r\n                amount\r\n                currencyCode\r\n              }\r\n              discountApplication {\r\n                ... on ScriptDiscountApplication {\r\n                  __typename\r\n                  title\r\n                  targetType\r\n                  targetSelection\r\n                  allocationMethod\r\n                  value {\r\n                    ... on MoneyV2 {\r\n                      __typename\r\n                      amount\r\n                      currencyCode\r\n                    }\r\n                    ... on PricingPercentageValue {\r\n                      __typename\r\n                      percentage\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      discountApplications(first: 100) {\r\n        edges {\r\n          node {\r\n            allocationMethod\r\n            targetSelection\r\n            targetType\r\n            ... on AutomaticDiscountApplication {\r\n              __typename\r\n              allocationMethod\r\n              targetSelection\r\n              targetType\r\n              title\r\n              value {\r\n                ... on MoneyV2 {\r\n                  __typename\r\n                  amount\r\n                  currencyCode\r\n                }\r\n              }\r\n            }\r\n            ... on DiscountCodeApplication {\r\n              __typename\r\n              allocationMethod\r\n              applicable\r\n              code\r\n              targetSelection\r\n              targetType\r\n              value\r\n            }\r\n            value {\r\n              ... on MoneyV2 {\r\n                __typename\r\n                amount\r\n                currencyCode\r\n              }\r\n              ... on PricingPercentageValue {\r\n                __typename\r\n                percentage\r\n              }\r\n            }\r\n            ... on ManualDiscountApplication {\r\n              description\r\n              value {\r\n                ... on MoneyV2 {\r\n                  __typename\r\n                  amount\r\n                }\r\n              }\r\n              title\r\n            }\r\n            ... on ScriptDiscountApplication {\r\n              __typename\r\n              title\r\n              value {\r\n                ... on MoneyV2 {\r\n                  __typename\r\n                  amount\r\n                  currencyCode\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      appliedGiftCards {\r\n        amountUsed {\r\n          amount\r\n          currencyCode\r\n        }\r\n        id\r\n        lastCharacters\r\n        presentmentAmountUsed {\r\n          amount\r\n          currencyCode\r\n        }\r\n        amountUsed {\r\n          amount\r\n          currencyCode\r\n        }\r\n        amountUsed {\r\n          amount\r\n          currencyCode\r\n        }\r\n        balance {\r\n          amount\r\n          currencyCode\r\n        }\r\n      }\r\n      lineItemsSubtotalPrice {\r\n        amount\r\n        currencyCode\r\n      }\r\n      subtotalPrice {\r\n        amount\r\n        currencyCode\r\n      }\r\n      totalPrice {\r\n        amount\r\n        currencyCode\r\n      }\r\n    }\r\n  }\r\n}\r\n",
          variables: {}
        })
      };
      console.log('in webview js',web_id);    
      $.ajax(settings).done(function (response){
        console.log('response-',response);
        var edges = response.data.node.lineItems.edges;
        console.log('edges',edges);
        var nodeFilter = jQuery.grep(edges, function(n, i){
          var nodeId = n.node.id;
          if(web_id == nodeId){
            return nodeId;
          }
        });
        console.log('nodeFilter',nodeFilter);
        var custAttr = nodeFilter[0].node.customAttributes;
        var attrWeb = jQuery.grep(custAttr, function(n, i){
          return (n !== "" && n != null && n.key == '_customized_attributes')
        });
        console.log('attrWeb',attrWeb);
        if(attrWeb[0]){
          var getWebAttr = attrWeb[0].value;
        }
        console.log('getWebAttr',getWebAttr);
        var getWebAttrData = JSON.parse(getWebAttr);
        console.log('getAttrData',getWebAttrData);
        getWebAttrData = getWebAttrData['attributes'];
        console.log('getWebAttrData',getWebAttrData);
        console.log('attributeObj--',attributeObj);
        attrObj(attributeObj);
        $.each(getWebAttrData, function(index, value){
          console.log('value',value);
          if(value == null){
            return;
          }
          if(getWebAttrData[index]['attributeName'] == "Rise"){
            var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Rise");
            var attrValue = value.values[0];
            var imgVal = getParameterByName('imageTitle',attrValue);
            if(imgVal == 'Low'){
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').addClass('activeradio');
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').closest('.ProductSize__Elements').addClass('active');
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').prop("checked", true);
              attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').attr('data-attr');
            }else if(imgVal == 'Mid'){
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').addClass('activeradio');
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.ProductSize__Elements').addClass('active');
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').prop("checked", true);
              attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').attr('data-attr');
            }else if(imgVal == 'High'){
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').addClass('activeradio');
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').closest('.ProductSize__Elements').addClass('active');
              $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').prop("checked", true);
              attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').attr('data-attr');
            }
          }
          else if(getWebAttrData[index]['attributeName'] == "Silhouette"){
            var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Silhouette");
            var attrValue = value.values[0];
            var imgVal = getParameterByName('imageTitle',attrValue);
            if(imgVal == 'Taper'){
              $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
              $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').addClass('activeradio');
              $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').closest('.ProductSize__Elements').addClass('active');
              $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').prop("checked", true);
              attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').attr('data-attr');
            }else if(imgVal == 'Straight'){
              $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
              $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').addClass('activeradio');
              $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').closest('.ProductSize__Elements').addClass('active');
              $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').prop("checked", true);
              attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').attr('data-attr');
            }
          }
          else if(getWebAttrData[index]['attributeName'] == "Length"){
            var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Length");
            var attrValue = value.values[0];
            var imgVal = getParameterByName('imageTitle',attrValue);
            if(imgVal == 'Standard'){
              $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
              $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').addClass('activeradio');
              $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').closest('.ProductSize__Elements').addClass('active');
              $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').prop("checked", true);
              attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').attr('data-attr');
            }else if(imgVal == 'Ankle'){
              $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
              $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').addClass('activeradio');
              $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').closest('.ProductSize__Elements').addClass('active');
              $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').prop("checked", true);
              attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').attr('data-attr');
            }
          }        
          else if(getWebAttrData[index]['attributeName'] == "Look"){
            var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Look");
            var attrValue = value.values[0];
            var imgVal = getParameterByName('imageTitle',attrValue);
            if(imgVal == 'Flat Press'){
              $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
              $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').addClass('activeradio');
              $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').closest('.ProductSize__Elements').addClass('active');
              $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').prop("checked", true);
              attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').attr('data-attr');
            }else if(imgVal == 'Crease'){
              $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
              $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').addClass('activeradio');
              $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').closest('.ProductSize__Elements').addClass('active');
              $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').prop("checked", true);
              attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').attr('data-attr');
            }
          }
        })
      });

    }else{// cartID API
      // new API setup
      // GraphQL query string
      const query = `
      query MyQuery {
        cart(id: "${ordeId}") {
          attributes {
            key
            value
          }
          checkoutUrl
          buyerIdentity {
            customer {
              displayName
              email
              firstName
              id
              lastName
            }
            countryCode
            email
          }
          lines(first: 250) {
            edges {
              node {
                attributes {
                  key
                  value
                }
                cost {
                  totalAmount {
                    amount
                    currencyCode
                  }
                  amountPerQuantity {
                    amount
                    currencyCode
                  }
                }
                id
              }
            }
          }
        }
      }`;
      
      // Function to fetch cart data
      async function fetchCartData() {
        try {
          const response = await fetch(`https://${shopURL}/api/2025-01/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': `${storefrontAccessToken}`, // Replace with your actual Storefront API access token
            },
            body: JSON.stringify({ query })
          });
      
          const data = await response.json();
      
          // Process the response data
          console.log('Cart data:>>>>>>>>>>>>', data);
          var edges = data.data.cart.lines?.edges;
          if(edges != undefined){
            console.log('edges',edges);
            var nodeFilter = jQuery.grep(edges, function(n, i){
              var nodeId = n.node.id;
              if(web_id == nodeId){
                return nodeId;
              }
            });
            console.log('nodeFilter',nodeFilter);
            var custAttr = nodeFilter[0].node.attributes;
            var attrWeb = jQuery.grep(custAttr, function(n, i){
              return (n !== "" && n != null && n.key == '_customized_attributes')
            });
            console.log('attrWeb',attrWeb);
            if(attrWeb[0]){
              var getWebAttr = attrWeb[0].value;
            }
            console.log('getWebAttr',getWebAttr);
            var getWebAttrData = JSON.parse(getWebAttr);
            console.log('getAttrData',getWebAttrData);
            getWebAttrData = getWebAttrData['attributes'];
            console.log('getWebAttrData',getWebAttrData);
            console.log('attributeObj--',attributeObj);
            attrObj(attributeObj);
            $.each(getWebAttrData, function(index, value){
              console.log('value',value);
              if(value == null){
                return;
              }
              if(getWebAttrData[index]['attributeName'] == "Rise"){
                var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Rise");
                var attrValue = value.values[0];
                var imgVal = getParameterByName('imageTitle',attrValue);
                if(imgVal == 'Low'){
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').addClass('activeradio');
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').closest('.ProductSize__Elements').addClass('active');
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').prop("checked", true);
                  attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').attr('data-attr');
                }else if(imgVal == 'Mid'){
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').addClass('activeradio');
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.ProductSize__Elements').addClass('active');
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').prop("checked", true);
                  attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').attr('data-attr');
                }else if(imgVal == 'High'){
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').addClass('activeradio');
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').closest('.ProductSize__Elements').addClass('active');
                  $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').prop("checked", true);
                  attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').attr('data-attr');
                }
              }
              else if(getWebAttrData[index]['attributeName'] == "Silhouette"){
                var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Silhouette");
                var attrValue = value.values[0];
                var imgVal = getParameterByName('imageTitle',attrValue);
                if(imgVal == 'Taper'){
                  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
                  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').addClass('activeradio');
                  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').closest('.ProductSize__Elements').addClass('active');
                  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').prop("checked", true);
                  attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Taper"]').attr('data-attr');
                }else if(imgVal == 'Straight'){
                  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
                  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').addClass('activeradio');
                  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').closest('.ProductSize__Elements').addClass('active');
                  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').prop("checked", true);
                  attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Silhouette [name="properties[_Silhouette?]"][value="Straight"]').attr('data-attr');
                }
              }
              else if(getWebAttrData[index]['attributeName'] == "Length"){
                var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Length");
                var attrValue = value.values[0];
                var imgVal = getParameterByName('imageTitle',attrValue);
                if(imgVal == 'Standard'){
                  $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
                  $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').addClass('activeradio');
                  $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').closest('.ProductSize__Elements').addClass('active');
                  $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').prop("checked", true);
                  attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').attr('data-attr');
                }else if(imgVal == 'Ankle'){
                  $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
                  $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').addClass('activeradio');
                  $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').closest('.ProductSize__Elements').addClass('active');
                  $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').prop("checked", true);
                  attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').attr('data-attr');
                }
              }        
              else if(getWebAttrData[index]['attributeName'] == "Look"){
                var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Look");
                var attrValue = value.values[0];
                var imgVal = getParameterByName('imageTitle',attrValue);
                if(imgVal == 'Flat Press'){
                  $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
                  $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').addClass('activeradio');
                  $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').closest('.ProductSize__Elements').addClass('active');
                  $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').prop("checked", true);
                  attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').attr('data-attr');
                }else if(imgVal == 'Crease'){
                  $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
                  $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').addClass('activeradio');
                  $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').closest('.ProductSize__Elements').addClass('active');
                  $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').prop("checked", true);
                  attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').attr('data-attr');
                }
              }
            });
          }
      
        } catch (error) {
          console.error('Error fetching cart data:', error);
        }
      }      
      // Call the function to fetch data
      fetchCartData();
      // new API setup -- END
    }

    }
  }
  $.each(cartdata,function(index,citem){
   var cindex = index+1;
    var itemhandle = citem.handle;
    var product_handle = $('.ProductForm__SizeContent').attr('prod-handle');
    if(itemhandle == product_handle && cindex == cart_itemid){
      $.each(citem.properties,function(index1,cprop){
       if(index1 == '_Rise?'){
          var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Rise");
          if(cprop == 'Low'){
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').addClass('activeradio');
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').closest('.ProductSize__Elements').addClass('active');
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').prop("checked", true);
            attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Low"]').attr('data-attr');
          }
          else if(cprop == 'Mid'){
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').addClass('activeradio');
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').closest('.ProductSize__Elements').addClass('active');
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').prop("checked", true);
            attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Rise [name="properties[_Rise?]"][value="Mid"]').attr('data-attr');
          }
          else if(cprop == 'High'){
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').addClass('activeradio');
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').closest('.ProductSize__Elements').addClass('active');
             $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').prop("checked", true);
            attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Rise [name="properties[_Rise?]"][value="High"]').attr('data-attr');
          }
        }
        else if(index1 == '_Length?'){
          var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Length");
          if(cprop == 'Standard'){
             $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
             $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').addClass('activeradio');
             $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').closest('.ProductSize__Elements').addClass('active');
             $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').prop("checked", true);
            attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Length [name="properties[_Length?]"][value="Standard"]').attr('data-attr');
          }
          else if(cprop == 'Ankle'){
             $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
             $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').addClass('activeradio');
             $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').closest('.ProductSize__Elements').addClass('active');
             $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').prop("checked", true);
            attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Length [name="properties[_Length?]"][value="Ankle"]').attr('data-attr');
          }
        } 
        else if(index1 == '_Look?'){
          var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Look");
          if(cprop == 'Flat Press'){
             $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
             $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').addClass('activeradio');
             $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').closest('.ProductSize__Elements').addClass('active');
             $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').prop("checked", true);
            attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Look [name="properties[_Look?]"][value="Flat Press"]').attr('data-attr');
          }
          else if(cprop == 'Crease'){
             $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').closest('.ProductSize__Elements').find('input').removeClass('activeradio');
             $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').addClass('activeradio');
             $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').closest('.ProductSize__Elements').addClass('active');
             $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').prop("checked", true);
            attributeObj[attrIndex]['values'][0] =  $('.ProductSize__Look [name="properties[_Look?]"][value="Crease"]').attr('data-attr');
          }
        }  
      })
      $('.new_measure').removeClass('hide');
      $('.size_messure_korra').removeClass('hide');
      $('.korrafitHtml').removeClass('hide');
    }
  });
  attrObj(attributeObj);
});

$(document).on("click",".semi_customizebtn",function(e){
  e.preventDefault();
  if(!document.body.classList.contains("temp_webview")){
    if(!document.querySelector('[data-pro-standard-size-main] input:checked[name="properties[_Standard Size?]"]') && document.querySelector('[data-pro-saved-sizing].hide')){
      $(".pro-customise-design-toast-msg").removeClass("hide");
      if(document.body.clientWidth <= 767){
        setTimeout(() => {
          $(".pro-customise-design-toast-msg").addClass("hide");
        },2000);
      }
      return false;
    }
  }
  $('body').addClass('open_semicustom');
  // if (window.history && window.history.pushState) {
  //   history.pushState(
  //     { url: document.location.href },
  //     document.title,
  //     "#modal"
  //   );
  //   $(window).on('popstate', function() {
  //     $('.new_measure_Exit_Popup').click();
  //   });
  // }
  // if (window.innerWidth < 768) {
  //   $('.new_measure_mobile').show();
  //    $('body').addClass('hidepdphead');
  //   $('.korra_size').hide();
  //   document.querySelector('#addtocart-handle')?.classList.add('custom-direct-addto-cart');
  // }
});

var subDesignAttrs = subAttr['designAttributes'] ? subAttr['designAttributes'] : [];
console.log('==subDesignAttrs',subDesignAttrs);

if(!document.body.classList.contains("temp_bsc") && !document.body.classList.contains("temp_picarioview")){
  console.log("semi-stitched...");
  
var semiHtml = '';
// var attributeObj = [];
var custObjKorraDef = {};
$.each(subDesignAttrs, function(index, value){
  // console.log("value>>>>>>",value);
  if(subDesignAttrs[index].values.length == 1){
    var hiddenElems = ' hide';
  }else{
    var hiddenElems = '';
  }
  semiHtml += '<div class="active ProductSize__Elements with-icon fromMetaField ProductSize__'+subDesignAttrs[index].attributeName+''+hiddenElems+'">';
  semiHtml += '<p class="ProductElements__Name">'+subDesignAttrs[index].attributeName+' <span class="error hide">Select '+subDesignAttrs[index].attributeName+'</span></p>';
  semiHtml += '<div class="Pair__Lists">';
  semiHtml += '<div class="List__numbers">';
  for (var i=0;i<subDesignAttrs[index].values.length;i++){
    // console.log("each loop",subDesignAttrs[index].attributeName);
    var imgattr = subDesignAttrs[index].values;
    // console.log("imgattr----------",imgattr);
    var alt = getParameterByNamekorra('imageTitle',imgattr[i]);
    var imageValue = getParameterByNamekorra('imageValue',imgattr[i]);
    if(i == 0){
      var activeclass = 'active'; 
      var activeradio = 'activeradio';
      var checked = 'checked';
      // attributeObj.push({"attributeName": subDesignAttrs[index].attributeName,"values": [imgattr[i]]});
      attributeObj.push({"attributeName": subDesignAttrs[index].attributeName,"values": imgattr});
    } else {
      var activeclass = '';
      var activeradio = '';
      var checked = '';
    }
    // attributeObj.push({"attributeName": subDesignAttrs[index].attributeName,"values": [imgattr[i]]});

    semiHtml += '<div class="Property__Field">';
    semiHtml += '<input '+checked+' data-attr="'+imgattr[i]+'" id="PreferredFit__'+subDesignAttrs[index].attributeName+'_'+imageValue+'" type="radio" name="properties[_'+subDesignAttrs[index].attributeName+'?]" value="'+imageValue+'" class="'+activeradio+'"><label for="PreferredFit__'+subDesignAttrs[index].attributeName+'_'+imageValue+'"><img src="'+imgattr[i]+'" alt="'+imageValue+'" loading="lazy"/>'+imageValue+'</label>';
    semiHtml += '</div>';
  }
  semiHtml += '</div>';
  semiHtml += '</div>';
  semiHtml += '</div>';
  $('.semiHtml').html(semiHtml);
  attrObj(attributeObj);
})
  console.log("attributeObj",attributeObj);
  const uniqueObj = (arr, props = []) => [...new Map(arr.map(entry => [props.map(k => entry[k]).join('|'), entry])).values()];
  attributeObj = uniqueObj(attributeObj, ['attributeName']);
  console.log("attributeObj",attributeObj);
var defObjnew = {};
defObjnew["attributes"] = attributeObj;
$('[name="properties[_defaultData]"]').val(JSON.stringify(defObjnew));
var defData = $('[name="properties[_defaultData]"]').val();
if(defData){
  // var getDefData = JSON.parse(defData);
  getDefData = JSON.parse(defData);
  getDefData = getDefData['attributes'];
}
}


$('.korra-save-custom-size').click(function(){
  setTimeout(() => {
    console.log("korra-save-custom-size>>>>>>>>>",$(this));
    if(document.querySelector("button.ProductForm__AddToCart")) document.querySelector("button.ProductForm__AddToCart").click();
    $(".ProductForm__AddToCart").addClass("btn_notclick");
    if(JSON.stringify(attributeObj) === JSON.stringify(getDefData)){
      console.log("inside if",attributeObj,getDefData);
      $('[name="properties[_customized_attributes]"]').val('');
    }else{
      console.log("inside else",attributeObj,getDefData);
      var differenceArrObj = {};
      var differenceArrObjA = [];
      $.each(attributeObj, function(index, value) {
        var isLastElement = index == attributeObj.length -1;
        if(attributeObj[index]['values'][0] != getDefData[index]['values'][0]){
          var imgattrDif = attributeObj[index].values;
          differenceArrObjA[index] = {"attributeName": attributeObj[index]['attributeName'],"values": [imgattrDif[0]]};
        }
        if(isLastElement){
          differenceArrObj["attributes"] = differenceArrObjA;
          if(differenceArrObj.attributes.length > 0 ){
            console.log("inside if last",JSON.stringify(differenceArrObj));
            $('[name="properties[_customized_attributes]"]').val(JSON.stringify(differenceArrObj));
          }else{
            console.log("inside else last");
            $('[name="properties[_customized_attributes]"]').val('');
          }
        }
      });
    }

    if(!document.body.classList.contains("temp_webview")){
      document.body.classList.remove("exit-customisation-alert");
      document.body.classList.remove('open_semicustom');
    }  
  }, 1000);
});

function addToCartHandle(){
  console.log('attributeObssj11',attributeObj);
  console.log('getCustomData11',getDefData);
  if(JSON.stringify(attributeObj) === JSON.stringify(getDefData)){
  $('[name="properties[_customized_attributes]"]').val('');
  }else{
  console.log('both diff');
  var differenceArrObj = {};
  var differenceArrObjA = [];
  
  $.each(attributeObj, function(index, value){
  var isLastElement = index == attributeObj.length -1;
  if(getDefData && getDefData.length > 0 && attributeObj[index]['values'][0] != getDefData[index]['values'][0]){
  var imgattrDif = attributeObj[index].values;
  differenceArrObjA[index] = {"attributeName": attributeObj[index]['attributeName'],"values": [imgattrDif[0]]};
  }
  if(isLastElement){
  differenceArrObj["attributes"] = differenceArrObjA;
  console.log('dissObj', differenceArrObj["attributes"])
  if(differenceArrObj.attributes.length > 0 ){
  console.log('one found')
  $('[name="properties[_customized_attributes]"]').val(JSON.stringify(differenceArrObj));
  }else{
  console.log('no found')
  $('[name="properties[_customized_attributes]"]').val('');
  }
  }
  });
  }
}

} // manageCustomizeSemiStitched -- end
if(document.body.classList.contains("template-product")){
  manageCustomizeSemiStitched();
}

$(document).on('click','.product-fitsmart-main:not(.shirt) .ProductSize__Elements [type="radio"], .new_customize .ProductSize__Elements [type="radio"]',function(){
  console.log("radio input click event",$(this));
  if(($(this).hasClass('activeradio') && $(this).closest(".ProductSize__Length").length > 0) || ($(this).hasClass('activeradio') && document.body.classList.contains("fitsmart-edit"))){
    console.log("inside return for FALSE",document.body.classList.contains("fitsmart-edit"),$(this).closest(".ProductSize__Length"));
    return false;
  }
  var sizeval = $(this).val();
  let sizeTable = {'XS':36,'S':38,'M':40,'L':42,'XL':44,'2XL':46,'3XL':48,'4XL':50,'5xl':52,'6xl':54,'7xl':56};
  if($(this).hasClass('activeradio')){
    console.log("hasClass activeradio");
    if(!$(this).closest(".ProductSize__Length").length > 0){
      // $(this).removeClass('activeradio');
      // $(this).closest('.ProductSize__Elements').removeClass('active');
    }
    $(this).prop("checked", false);
  }else{

    console.log("else activeradio");
    $(this).prop("checked", true);
    $(this).closest('.ProductSize__Elements').find('input').removeClass('activeradio');
    $(this).addClass('activeradio');
    $(this).closest('.ProductSize__Elements').addClass('active');
  }
  if(pdpType_low == 'jackets' || pdpType_low == 'suit blazer' || pdpType_low == 'long jackets' || pdpType_low == 'bundi'){
    if($(this).closest('.ProductSize__Elements').hasClass('ProductSize__BodyType')){
      console.log("bodyType clicked",sizeval);
      if(sizeval == 'athletic'){
        $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Slim"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Standard"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="36"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="38"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="40"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="42"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="44"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="46"]').closest('.Property__Field').addClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="48"]').closest('.Property__Field').addClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="50"]').closest('.Property__Field').addClass('hide');
        var checkedsizeValue = $('.ProductSize__Elements.ProductSize__ShirtSize .activeradio[name="properties[_Size?]"]').val();
        console.log("checkedsizeValue",sizeTable[checkedsizeValue]);
        if(checkedsizeValue > 44){
          $('.ProductSize__ShirtSize [type="radio"]').prop('checked',false).removeClass('activeradio');
          $('.ProductSize__ShirtSize').removeClass('active');
        }
      }else if(sizeval == 'average'){
        $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Slim"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Standard"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="36"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="38"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="40"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="42"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="44"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="46"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="48"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="50"]').closest('.Property__Field').addClass('hide');
        var checkedsizeValue = $('.ProductSize__Elements.ProductSize__ShirtSize .activeradio[name="properties[_Size?]"]').val();
        if(checkedsizeValue > 48){
          $('.ProductSize__ShirtSize [type="radio"][value="50"]').prop('checked',false).removeClass('activeradio');
          $('.ProductSize__ShirtSize').removeClass('active');
        }
      }else if(sizeval == 'healthy'){
        $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Slim"]').closest('.Property__Field').addClass('hide');
        $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Standard"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="36"]').closest('.Property__Field').addClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="38"]').closest('.Property__Field').addClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="40"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="42"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="44"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="46"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="48"]').closest('.Property__Field').removeClass('hide');
        $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="50"]').closest('.Property__Field').removeClass('hide');
        var checkedsizeValue = $('.ProductSize__Elements.ProductSize__ShirtSize .activeradio[name="properties[_Size?]"]').val();
        var activefit = $('.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Slim"]').hasClass('activeradio');
        if(checkedsizeValue < 40){
          $('.ProductSize__ShirtSize [type="radio"]').prop('checked',false).removeClass('activeradio');
          $('.ProductSize__ShirtSize').removeClass('active');
          $('.ProductSize__PreferredFit [type="radio"]').prop('checked',false).removeClass('activeradio');
        }
        if(activefit){
          $('.ProductSize__PreferredFit').removeClass('active')
        }
      }
      // if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`) && !document.body.classList.contains("fitsmart-edit")){
      //   let getVal = document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`).value;
      //   // let sizeTableN = {'xs':36,'s':38,'m':40,'l':42,'xl':44,'xxl':46,'xxxl':48,'4xl':50,'5xl':52,'6xl':54,'7xl':56};
      //   // getVal = sizeTableN[getVal];
      //   console.log("getVal",getVal);
      //   let needToActionForSize = false;
      //   if(s_value == 'athletic'){
      //     if(getVal > 44){
      //       needToActionForSize = true;
      //     }
      //   }else if(s_value == 'average'){
      //     if(getVal > 48){	
      //       needToActionForSize = true;
      //     }
      //   }else if(s_value == 'healthy'){
      //     if(getVal < 40){
      //       needToActionForSize = true;
      //     }
      //   }
      //   console.log("needToActionForSize",needToActionForSize);
      //   if(needToActionForSize){
      //     document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`)?.classList.remove("activeradio");
      //     document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"].activeradio`)?.classList.remove("activeradio");
      //     if(document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`)) document.querySelector(`[data-fitsmart-questions-main] [name="properties[_Size?]"]:checked`).checked = false;
      //   }
      // }
    }    
    var activeBodytype = $('.ProductSize__Elements.ProductSize__BodyType').hasClass('active');
    if(activeBodytype){
      console.log("yes");
    }else{
      console.log("no");
      $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Slim"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__PreferredFit [name="properties[_Preferred Fit?]"][value="Standard"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="36"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="38"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="40"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="42"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="44"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="46"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="48"]').closest('.Property__Field').removeClass('hide');
      $('.ProductSize__Elements.ProductSize__ShirtSize [name="properties[_Size?]"][value="50"]').closest('.Property__Field').removeClass('hide');
    }
  }

  // var subDesignAttrs = subAttr['designAttributes'] ? subAttr['designAttributes'] : [];
  // console.log('==subDesignAttrs',subDesignAttrs);

  // var attributeObj = [];
  // var getDefData = [];
  // if(!document.body.classList.contains("temp_bsc") && !document.body.classList.contains("temp_picarioview")){
  //   $.each(subDesignAttrs, function(index, value){
  //     for (var i=0;i<subDesignAttrs[index].values.length;i++){
  //       console.log("each loop",subDesignAttrs[index].attributeName);
  //       var imgattr = subDesignAttrs[index].values;
  //       var alt = getParameterByNamekorra('imageTitle',imgattr[i]);
  //       var imageValue = getParameterByNamekorra('imageValue',imgattr[i]);
  //       if(i == 0){
  //         attributeObj.push({"attributeName": subDesignAttrs[index].attributeName,"values": [imgattr[i]]}); 
  //       }
  //     }
  //     attrObj(attributeObj);
  //   });
  //   var defObjnew = {};
  //   defObjnew["attributes"] = attributeObj;
  //   $('[name="properties[_defaultData]"]').val(JSON.stringify(defObjnew));
  //   var defData = $('[name="properties[_defaultData]"]').val();
  //   if(defData){
  //   getDefData = JSON.parse(defData);
  //   getDefData = getDefData['attributes'];
  //   }
  // }

  console.log("attributeObj",attributeObj);
  if($(this).closest('.ProductSize__Elements').hasClass('ProductSize__Rise')){
    var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Rise");
    attributeObj[attrIndex]['values'][0] =  $(this).attr('data-attr');
    $('[name="properties[_Rise?]"]').val(getParameterByNamekorra('imageValue',$(this).attr('data-attr')));
  }else if($(this).closest('.ProductSize__Elements').hasClass('ProductSize__Length')){
    var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Length");
    attributeObj[attrIndex]['values'][0] =  $(this).attr('data-attr');
  }else if($(this).closest('.ProductSize__Elements').hasClass('ProductSize__Look')){
    var attrIndex = attributeObj.findIndex(x=> x.attributeName == "Look");
    attributeObj[attrIndex]['values'][0] =  $(this).attr('data-attr');
  }
  console.log('attributeOb',attributeObj);
  attrObj(attributeObj);  
  if(JSON.stringify(attributeObj) === JSON.stringify(getDefData)){
    $('[name="properties[_customized_attributes]"]').val('');
  }else{
    var differenceArrObj = {};
    var differenceArrObjA = [];    
    $.each(attributeObj, function(index, value){
      var isLastElement = index == attributeObj.length -1;
      if(getDefData){
        if(attributeObj[index]['values'][0] != getDefData[index]['values'][0]){
          var imgattrDif = attributeObj[index].values;
          differenceArrObjA[index] = {"attributeName": attributeObj[index]['attributeName'],"values": [imgattrDif[0]]};
        }
      }      
      if(isLastElement){
        differenceArrObj["attributes"] = differenceArrObjA;
        if(differenceArrObj.attributes.length > 0 ){
          $('[name="properties[_customized_attributes]"]').val(JSON.stringify(differenceArrObj));
        }else{
          $('[name="properties[_customized_attributes]"]').val('');
        }
      }
    });
  }

  if($('.ProductSize__Elements.ProductSize__BodyType [name="properties[_Body Type?]"]:checked').length > 0){
    let bType = $('.ProductSize__Elements.ProductSize__BodyType [name="properties[_Body Type?]"]:checked').val();
    if(bType == "healthy"){
      $(".preferredfit-item-list-jacket-full").addClass("hide");
      $(".preferredfit-item-list-jacket-half").removeClass("hide");
    }else{
      $(".preferredfit-item-list-jacket-full").removeClass("hide");
      $(".preferredfit-item-list-jacket-half").addClass("hide");
      initFitsmartSliders();
    }
  }
  
  $(this).closest('.ProductSize__Elements').find('.error').addClass('hide');
  questionsCounter();
});


// let sizeGuideTables = document.querySelectorAll(".pro-sizechart-table-main table.shirtsize_inch, .pro-sizechart-table-main table.shirtsize_cm, .preferredfit-item-list");
// if(sizeGuideTables.length > 0){
//   sizeGuideTables.forEach(sliderEle => {
//     if(sliderEle.querySelectorAll("thead th").length > 2){
//       // console.log("size guide sliderEle",sliderEle);
//       draggableTable(sliderEle.closest(".ProductSize__ChartTable"));
//     }
//   });
// }
// let pf_fitTips = document.querySelector(`.preferredfit-item-list`);
// if(pf_fitTips){
//   draggableTable(pf_fitTips);
// }


function updateShirtSizeTable() {
  const bodyProdType = document.body.getAttribute("data-type");
  if (bodyProdType == "suit blazer") {
    let checkedBodyType = $('input[name="properties[_Body Type?]"]:checked').data('value') || $('input[name="properties[_Body Type?]_edit"]:checked').data('value');
    let selectedFit = '';

    // Edit drawer fit first
    if ($('#edit_PreferredFit__SuperSlim').is(':checked')) { 
      selectedFit = 'PreferredFit__SuperSlim';
    } else if ($('#edit_PreferredFit__Structured').is(':checked')) {
      selectedFit = 'PreferredFit__Structured';
    } else {
      selectedFit = $('input[name="properties[_Preferred Fit?]"]:checked').attr('id');
    }

    if (!checkedBodyType) {
        checkedBodyType = 'Athletic';
        $('input[name="properties[_Body Type?]"][data-value="Athletic"]').prop('checked', true);
    }

    if (!selectedFit) {
        selectedFit = 'PreferredFit__SuperSlim';
        $('#PreferredFit__SuperSlim').prop('checked', true);
    }

    checkedBodyType = checkedBodyType.toLowerCase();

    const prefedfit_guide_full = document.querySelector('.preferredfit-item-list-jacket-full');
    const prefedfit_guide_half = document.querySelector('.preferredfit-item-list-jacket-half');

    if (checkedBodyType === "healthy") {
        prefedfit_guide_full?.classList.add('hide');
        prefedfit_guide_half?.classList.remove('hide');
    } else {
        prefedfit_guide_full?.classList.remove('hide');
        prefedfit_guide_half?.classList.add('hide');
    }

    $('.shirtsize_inch.suitblazertable, .shirtsize_cm.suitblazertable').addClass('hide');

    if (checkedBodyType === "healthy") {
        $('.shirtsize_inch.suitblazertable.healthy, .shirtsize_cm.suitblazertable.healthy').removeClass('hide');
        return;
    }

    $(`.shirtsize_inch.suitblazertable.${checkedBodyType}[data-fit="${selectedFit}"], .shirtsize_cm.suitblazertable.${checkedBodyType}[data-fit="${selectedFit}"]`).removeClass('hide');
  }
}

$(document).on('change',`input[name="properties[_Preferred Fit?]"],input[name="properties[_Body Type?]"],.inside-sizechart-inch-cm-checkbox`,
    function () {
      updateShirtSizeTable();
    }
);

$(document).on('click', `[data-pro-inside-fitsmart-guide],[data-pro-custom-fitsmart-guide]`,
    function () {
      setTimeout(function () {
          updateShirtSizeTable();
      }, 50);
    }
);


$(document).on('click','.product-fitsmart-main:not(.shirt) .ProductSize__Elements [type="radio"], .new_customize .ProductSize__Elements [type="radio"]',function(){
  console.log("radio input click event",$(this));
  var sizeval = $(this).val();
  if(pdpType_low == 'long jackets' || pdpType_low == 'suit blazer'){
    if($(this).closest('.ProductSize__Elements').hasClass('ProductSize__BodyType')){
      console.log("bodyType clicked",sizeval);
      if(sizeval == 'athletic'){
        // inches table
        $('.shirtsize_inch.athletic').removeClass('hide');
        $('.shirtsize_inch.average').addClass('hide');
        $('.shirtsize_inch.healthy').addClass('hide');
        // cm table
        $('.shirtsize_cm.athletic').removeClass('hide');
        $('.shirtsize_cm.average').addClass('hide');
        $('.shirtsize_cm.healthy').addClass('hide');
      }else if(sizeval == 'average'){
        // inches table
        $('.shirtsize_inch.athletic').addClass('hide');
        $('.shirtsize_inch.average').removeClass('hide');
        $('.shirtsize_inch.healthy').addClass('hide');
        // cm table
        $('.shirtsize_cm.athletic').addClass('hide');
        $('.shirtsize_cm.average').removeClass('hide');
        $('.shirtsize_cm.healthy').addClass('hide');
      }else if(sizeval == 'healthy'){
        // inches table
        $('.shirtsize_inch.athletic').addClass('hide');
        $('.shirtsize_inch.average').addClass('hide');
        $('.shirtsize_inch.healthy').removeClass('hide');
        // cm table
        $('.shirtsize_cm.athletic').addClass('hide');
        $('.shirtsize_cm.average').addClass('hide');
        $('.shirtsize_cm.healthy').removeClass('hide');
      }
    }
  }
})